import { useState } from 'react';
import { contactInfo } from '@/mocks/home';

export default function Contact() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;

    const honeypot = (form.elements.namedItem('phone_alt') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setFormStatus('success');
      return;
    }

    const formData = new FormData(form);

    try {
      const res = await fetch('https://readdy.ai/api/form/d9lgm8kit35ii3jdl800', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await res.text();
      let parsed: Record<string, unknown> | null = null;
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      if (res.ok && parsed && (parsed as Record<string, unknown>).code === 'OK') {
        setFormStatus('success');
        setFormError('');
        form.reset();
      } else {
        const msg =
          (parsed as Record<string, unknown> | null)?.meta &&
          typeof ((parsed as Record<string, unknown>).meta as Record<string, unknown>)?.message === 'string'
            ? ((parsed as Record<string, unknown>).meta as Record<string, unknown>).message
            : (parsed as Record<string, unknown> | null)?.message && typeof (parsed as Record<string, unknown>).message === 'string'
              ? (parsed as Record<string, unknown>).message
              : '提交失败，请稍后再试';
        setFormStatus('error');
        setFormError(String(msg));
      }
    } catch {
      setFormStatus('error');
      setFormError('网络错误，请检查网络连接后重试');
    }
  };

  return (
    <section id="contact" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2">{contactInfo.title}</h2>
          <p className="text-sm text-foreground-600 mb-1">{contactInfo.subtitle}</p>
          <p className="text-sm text-foreground-600">{contactInfo.desc}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="bg-background-50 rounded-xl p-6">
            <h3 className="font-heading text-lg text-foreground-900 mb-4">联系方式</h3>
            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 flex-shrink-0">
                  <i className="ri-mail-line text-lg text-primary-600"></i>
                </div>
                <div>
                  <div className="text-xs text-foreground-500">投稿邮箱</div>
                  <div className="text-sm font-medium text-foreground-800">{contactInfo.email}</div>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 flex-shrink-0">
                  <i className="ri-wechat-line text-lg text-accent-600"></i>
                </div>
                <div>
                  <div className="text-xs text-foreground-500">官方微信</div>
                  <div className="text-sm font-medium text-foreground-800">{contactInfo.wechat}</div>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 flex-shrink-0">
                  <i className="ri-time-line text-lg text-secondary-600"></i>
                </div>
                <div>
                  <div className="text-xs text-foreground-500">响应时间</div>
                  <div className="text-sm font-medium text-foreground-800">24小时内回复</div>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-background-50 rounded-xl p-6">
            <h3 className="font-heading text-lg text-foreground-900 mb-4">快速投稿</h3>
            <form onSubmit={handleSubmit} data-readdy-form>
              <div className="space-y-3">
                <input
                  type="text"
                  name="title"
                  placeholder="爆料标题"
                  className="w-full px-4 py-2.5 text-sm bg-background-100 rounded-lg border border-background-200/70 text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                  required
                />
                <select
                  name="category"
                  className="w-full px-4 py-2.5 text-sm bg-background-100 rounded-lg border border-background-200/70 text-foreground-800 focus:outline-none focus:border-primary-400 transition-colors cursor-pointer"
                  required
                >
                  <option value="">选择分类</option>
                  <option value="明星八卦">明星八卦</option>
                  <option value="网红爆料">网红爆料</option>
                  <option value="综艺内幕">综艺内幕</option>
                  <option value="影视剧组">影视剧组</option>
                  <option value="直播圈">直播圈</option>
                  <option value="其他">其他</option>
                </select>
                <textarea
                  name="content"
                  placeholder="请详细描述你要爆料的瓜（500字以内）"
                  rows={4}
                  maxLength={500}
                  className="w-full px-4 py-2.5 text-sm bg-background-100 rounded-lg border border-background-200/70 text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                  required
                ></textarea>
                <input
                  type="email"
                  name="email"
                  placeholder="你的邮箱（选填，用于回复）"
                  className="w-full px-4 py-2.5 text-sm bg-background-100 rounded-lg border border-background-200/70 text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                />
                <input
                  type="text"
                  name="phone_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="honeypot-field"
                />
                <button
                  type="submit"
                  className="w-full py-3 bg-primary-500 text-white font-medium rounded-lg hover:bg-primary-600 transition-colors text-sm whitespace-nowrap cursor-pointer"
                >
                  提交爆料 <i className="ri-send-plane-line ml-1"></i>
                </button>
              </div>
              {formStatus === 'success' && (
                <div className="mt-3 text-sm text-accent-700 bg-accent-100 rounded-lg px-4 py-2 text-center">
                  投稿已提交，我们会尽快审核！感谢你的爆料！
                </div>
              )}
              {formStatus === 'error' && (
                <div className="mt-3 text-sm text-primary-700 bg-primary-100 rounded-lg px-4 py-2 text-center">
                  {formError}
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}